/**
 * 세부지명 요청 등록 폼데이터
 */
export class FormDataRequestMap {
    /** 작업 타입 (추가 / 수정) */
    operationType = 'CREATE';
    /** 바로고, 다음 */
    addressSource = 'BAROGO';
    /** 지역 타입 코드 SEOUL.. */
    areaTypeCode = null;
    /** 지역 타입 한글 */
    areaTypeKr = null;
    /** 읍면동 */
    eupMyeonDong = '';
    /** 리 */
    ri = '';
    /** 메인 번지 */
    mainLotNumber = '';
    /** 보조 번지 */
    subLotNumber = '';
    /** 주소 타입 */
    type = 'LOT_NUMBER';
    /** 좌표 변경 여부 */
    isChangePosition = false;
    /** 수정할 좌표 */
    newPosition = null;
    /** 지명구분 (작업 상세 타입) */
    operationDetailType = 'PLACE_NAME';
    /** 세부명칭 (신주소의 건물명이 세부명칭과 같은 것이다.) */
    buildingName = '';
    /** 행정동(특수지명) */
    administrativeArea = '';
    /** 선택한 주소 */
    selectedAddress = null;
    constructor(data) {
        if (!data) {
            return;
        }
        // get set 없이 딱 필드만 있게 하기 위해 중간에 처리
        const cls = new FormDataRequestMap();
        Object.getOwnPropertyNames(cls).forEach((it) => {
            const value = data[it];
            this[it] = value;
        });
    }
}
